import React from 'react';
import { Card, Table } from 'antd';
import {
  arrangedReservationColumns,
  historyReservationColumns,
  waitArrangeReservationColumns,
} from '../tableColumns';

interface ArrangementTableData {
  key: string | undefined;
  createdTime: string | undefined;
  reservationTime: string;
  householdNumber: string;
  name: string | undefined;
  action: string[];
}
[];

interface ArrangementTableProps {
  tab: string;
  dataSource: ArrangementTableData[];
}

const ArrangementTable = ({ tab, dataSource }: ArrangementTableProps) => {
  const getTableData = () => {
    switch (tab) {
      case '待安排':
        return {
          columns: waitArrangeReservationColumns,
          dataSource,
        };

      case '已安排':
        return {
          columns: arrangedReservationColumns,
          dataSource,
        };

      default:
        return {
          columns: historyReservationColumns,
          dataSource,
        };
    }
  };

  return (
    <Card>
      <Table
        columns={getTableData().columns}
        dataSource={getTableData().dataSource}
        scroll={{ x: 'max-content' }}
      />
    </Card>
  );
};

export default ArrangementTable;
